import {
  CompanyTechTagsMutationAction, CompanyTechTagsMutationPayload, CompanyTechTagsUpdateAction,
  CompanyTechTagsUpdatePayload,
  COMPANY_TECH_TAGS_MUTATE_START,
  COMPANY_TECH_TAGS_UPDATE
} from './types';

export const companyTechTagsActions = {
  companyTechTagsUpdate: (payload: CompanyTechTagsUpdatePayload): CompanyTechTagsUpdateAction => ({
    type: COMPANY_TECH_TAGS_UPDATE,
    payload,
  }),

  updateCompanyTags: (payload: CompanyTechTagsMutationPayload): CompanyTechTagsMutationAction => ({
    type: COMPANY_TECH_TAGS_MUTATE_START,
    payload,
  })
};
